export const useBootstrapConfiguration = (environment: any): void => {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  (window as any).paymentIqCardEncrypterUrl =
    environment.paymentIqCardEncrypterUrl;
};
